/** Sidebar information architecture — mirrors the prototype's nav (spec §7.1). */
export interface NavItem {
  to: string;
  label: string;
  icon: string;
  group: 'Sourcing' | 'Portfolio' | 'Tools';
  /** Hidden from the sidebar for non-admins. The page and its API enforce this too. */
  adminOnly?: boolean;
}

export const NAV: NavItem[] = [
  { to: '/deals', label: 'Deals', icon: '▦', group: 'Sourcing' },
  { to: '/tasks', label: 'My Tasks', icon: '☑', group: 'Sourcing' },
  { to: '/intake', label: 'Intake', icon: '✷', group: 'Sourcing' },
  { to: '/calls', label: 'Call Inbox', icon: '🎙', group: 'Sourcing' },
  { to: '/deals/new', label: 'Add Deal', icon: '＋', group: 'Sourcing' },
  { to: '/portfolio', label: 'Monitoring', icon: '◉', group: 'Portfolio' },
  { to: '/analytics', label: 'Fund Analytics', icon: '📈', group: 'Portfolio' },
  { to: '/calibration', label: 'Score Calibration', icon: '🎯', group: 'Tools' },
  { to: '/peers', label: 'Peer Multiples', icon: '📊', group: 'Tools' },
  { to: '/research', label: 'Research', icon: '📚', group: 'Tools' },
  { to: '/activity', label: 'Activity log', icon: '🕑', group: 'Tools' },
  { to: '/archive', label: 'Archive', icon: '🗄', group: 'Tools', adminOnly: true },
  { to: '/settings', label: 'Settings', icon: '⚙', group: 'Tools' },
];
